export enum SnoozeBy {
  MINUTE_20,
  HOUR_1,
  HOUR_3,
  TOMORROW,
  MONDAY,
}
